import * as _ from 'lodash'
import * as React from 'react'
import * as ReactDOM from 'react-dom'

export interface IJsTreeChangedEvent {
  selected: string[]
  action: string
  event: JQuery.Event
  instance: any
  node: any
}

interface IJsTreeProps {
  options: JSTreeStaticDefaults
  defaultTree?: string
  selectedInput?: string
  onChange?: (selected: string[]) => void
  selected?: string[]
}

export class JsTree extends React.Component<IJsTreeProps, {}> {
  treeNode: JQuery
  lastOptions: JSTreeStaticDefaults

  componentDidMount() {
    this.updateJsTree()
  }

  componentWillUnmount() {
    this.destroyInstance()
  }

  componentWillReceiveProps(props: IJsTreeProps) {
    this.updateJsTree(props)
  }

  destroyInstance(sendClearToOnChange = false, props = this.props) {
    const { onChange = () => {/**/ } } = this.props

    if (this.treeNode) {
      this.treeNode.off('changed.jstree')
      this.treeNode.off('loaded.jstree')
      this.treeNode.jstree('destroy')
      this.treeNode = undefined
    }

    if (sendClearToOnChange) {
      onChange([])
    }
  }

  updateJsTree(props = this.props) {
    const compareOptionsCustomizer = (v1: any, v2: any) => {
      if (typeof v1 === 'function' && typeof v2 === 'function') {
        // Don't Compare Functions when updating JsTree
        return true
      }

      //allow other comparisons to run by not returning anything
    }
    const { onChange = () => {/**/ }, selected = [] } = props
    const componentElem = ReactDOM.findDOMNode(this)
    const shouldUpdate = !_.isEqualWith(this.lastOptions, props.options, compareOptionsCustomizer)
    this.lastOptions = props.options

    if (shouldUpdate) {
      this.destroyInstance(true, props)
    }

    if (!this.treeNode) {
      this.treeNode = $(componentElem).jstree(props.options)

      //Select Nodes
      this.treeNode.on('loaded.jstree', () => {
        this.updateSelectedNodes(props, true)

        //onChange Listener
        this.treeNode.on('changed.jstree', (ev, treeEvent: IJsTreeChangedEvent) => {
          onChange(treeEvent.selected)
        })
      })
    } else {
      this.updateSelectedNodes(props)
    }
  }

  updateSelectedNodes(props, deselectAll = false) {
    const { selected = [] } = props

    if (!this.treeNode) {
      return
    }

    if (deselectAll) {
      const jsTree = this.treeNode.jstree(true)
      jsTree.deselect_all()
      jsTree.close_all()
      jsTree.open_node(jsTree.get_json())
      this.treeNode.jstree('deselect_all')
    }

    selected.forEach((selectedNode) => {
      this.treeNode.jstree('select_node', selectedNode)
    })
  }

  render() {
    return (
      <div data-defaulttree={this.props.defaultTree} data-selectedinput={this.props.selectedInput}></div>
    )
  }
}
